import {v4 as $65sWz$v4} from "uuid";



const $98e41f666f9d4fc7$export$7d576a40358207c0 = [
    "cvv",
    "expirationDate",
    "cardNumber"
];
var $98e41f666f9d4fc7$export$bdb47a4f704771fb = /*#__PURE__*/ function(GlobalPostMessageEventKind) {
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_ERROR"] = "PAYMENT_CARD_FETCH_ERROR";
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_SUCCESS"] = "PAYMENT_CARD_FETCH_SUCCESS";
    // Input/configuration error kind
    GlobalPostMessageEventKind["CARD_VIEWER_INPUT_ERROR"] = "CARD_VIEWER_INPUT_ERROR";
    GlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    GlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    GlobalPostMessageEventKind["TOGGLE_CARD_NUMBER_MASK"] = "TOGGLE_CARD_NUMBER_MASK";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_ERROR"] = "COPY_TO_CLIPBOARD_ERROR";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_SUCCESS"] = "COPY_TO_CLIPBOARD_SUCCESS";
    GlobalPostMessageEventKind["CARD_VIEWER_READY"] = "CARD_VIEWER_READY";
    return GlobalPostMessageEventKind;
}({});
const $98e41f666f9d4fc7$export$2c01c8e4e45fe626 = "CARD_VIEWER_HANDSHAKE_INIT";
const $98e41f666f9d4fc7$export$cafd44f6efa311b9 = "CARD_VIEWER_HANDSHAKE_ACK";
const $98e41f666f9d4fc7$export$18c5bbe5ce57ac80 = "CARD_VIEWER_CONFIGURE";


const $33a93507c43eb206$export$1ec34c2c9b231c0f = [
    "pin",
    "cardNumber",
    "expirationMonth",
    "expirationYear",
    "expirationDate",
    "securityCode"
];
const $33a93507c43eb206$export$2db53370b14e73a1 = [
    "visa",
    "mastercard",
    "amex",
    "discover"
];
var $33a93507c43eb206$export$5278e3e6401288b4 = /*#__PURE__*/ function(SecureInputsGlobalPostMessageEventKind) {
    SecureInputsGlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    SecureInputsGlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    SecureInputsGlobalPostMessageEventKind["USER_INPUT_ERROR"] = "USER_INPUT_ERROR";
    SecureInputsGlobalPostMessageEventKind["REQUEST_ERROR"] = "REQUEST_ERROR";
    SecureInputsGlobalPostMessageEventKind["ON_INPUT"] = "ON_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_SUBMIT"] = "ON_SUBMIT";
    SecureInputsGlobalPostMessageEventKind["CHANGE_CARD_PIN"] = "CHANGE_CARD_PIN";
    SecureInputsGlobalPostMessageEventKind["TOKENIZE_CARD"] = "TOKENIZE_CARD";
    SecureInputsGlobalPostMessageEventKind["ON_CARD_INPUT"] = "ON_CARD_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_PIN_CHANGE_SUCCESS"] = "ON_PIN_CHANGE_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_TOKENIZE_CARD_SUCCESS"] = "ON_TOKENIZE_CARD_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_STATE_CHANGE"] = "ON_STATE_CHANGE";
    SecureInputsGlobalPostMessageEventKind["ON_READY"] = "ON_READY";
    return SecureInputsGlobalPostMessageEventKind;
}({});






var $f0e798bc2262278c$export$c278f139ce6eedba = /*#__PURE__*/ function(CheckoutPostMessageKind) {
    CheckoutPostMessageKind["TOKENIZE_SUCCCESS"] = "TOKENIZE_SUCCCESS";
    CheckoutPostMessageKind["TOKENIZE_ERROR"] = "TOKENIZE_ERROR";
    CheckoutPostMessageKind["CHECKOUT_READY"] = "CHECKOUT_READY";
    return CheckoutPostMessageKind;
}({});
class $f0e798bc2262278c$export$4e94f40711c15818 extends Error {
    constructor(message, errors){
        super(message), this.name = "CheckoutConfigInputError";
        this.errors = errors;
    }
}
const $f0e798bc2262278c$export$e65600b7ad68fd67 = [
    "Pay",
    "Submit"
];


const $2067059a23a16700$export$8acf5617026d4b16 = [
    "borderRadius",
    "backgroundColor",
    "color",
    "cursor",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "userSelect",
    "border"
];
const $2067059a23a16700$export$93b12edf1b0f1762 = [
    ":focus",
    ":hover",
    ":invalid",
    ":valid"
];
const $2067059a23a16700$export$679b0194e2408a3e = [
    "live",
    "test"
];



var $95cf62aa3aa07e58$exports = {};
$95cf62aa3aa07e58$exports = JSON.parse("{\"name\":\"@highnoteplatform/secure-inputs\",\"version\":\"1.8.1\",\"description\":\"Secure input fields for your customer.\",\"source\":\"src/index.ts\",\"access\":\"public\",\"main\":\"lib/index.js\",\"module\":\"lib/esm/module.js\",\"types\":\"lib/types.d.ts\",\"files\":[\"lib\",\"README.md\"],\"scripts\":{\"clean\":\"rimraf lib dist\",\"prebuild\":\"npm run clean\",\"build\":\"PARCEL_WORKER_BACKEND=process parcel build --detailed-report --no-scope-hoist --no-cache\",\"postbuild\":\"node ../../scripts/fix-node-env.js\",\"prepublishOnly\":\"npm run build\",\"test\":\"jest\",\"test:watch\":\"jest --watch\",\"prepack\":\"npm run build\",\"predev\":\"npm run clean\",\"dev\":\"parcel watch --port 3005 --hmr-port 2005 --no-cache --dist-dir=lib\"},\"author\":\"packages@highnote.com\",\"license\":\"MIT\",\"homepage\":\"https://highnote.com\",\"devDependencies\":{\"@highnoteplatform/types\":\"*\",\"@types/jest\":\"28.1.8\",\"@types/uuid\":\"^9.0.1\",\"@types/jsdom\":\"21.1.1\",\"@types/node\":\"^22.0.0\",\"eslint-plugin-jest\":\"27.2.1\",\"jest\":\"^28.1.3\",\"jest-environment-jsdom\":\"^29.5.0\",\"jsdom\":\"21.1.1\",\"ts-jest\":\"28.0.8\"},\"targets\":{\"main\":{\"includeNodeModules\":[\"@highnoteplatform/types\"],\"optimize\":true},\"module\":{\"includeNodeModules\":[\"@highnoteplatform/types\"],\"optimize\":true}},\"dependencies\":{\"uuid\":\"^11.0.0\"}}");


const { SECURE_INPUTS_IFRAME_PORT: $79deca1ff5cf929a$var$SECURE_INPUTS_IFRAME_PORT = 3006 } = process.env;
const $79deca1ff5cf929a$var$packageVersion = (0, $95cf62aa3aa07e58$exports.version) ?? "";
const $79deca1ff5cf929a$export$f76cea9319723dd2 = process.env.NODE_ENV === "production" ? "https://cdn.highnote.com" : `http://localhost:${$79deca1ff5cf929a$var$SECURE_INPUTS_IFRAME_PORT}`;
const $79deca1ff5cf929a$var$iframePath = (apiEnvironment)=>{
    let path = "";
    if (process.env.NODE_ENV === "production") path = `secure-inputs/${$79deca1ff5cf929a$var$packageVersion}/`;
    return apiEnvironment === "test" ? `${path}index_test.html` : `${path}index.html`;
};
const $79deca1ff5cf929a$export$1c3aefb711c3a4cc = ()=>(0, $65sWz$v4)();
const $79deca1ff5cf929a$export$f7872bdb68630f49 = (apiEnvironment)=>`${$79deca1ff5cf929a$export$f76cea9319723dd2}/${$79deca1ff5cf929a$var$iframePath(apiEnvironment)}`;


const $cef9da35d4d969ce$var$buildFrameSource = (config)=>{
    const { clientToken: clientToken, elementConfig: elementConfigMap, field: field, environment: environment, uuid: uuid, fields: fields, excludedCardBrands: excludedCardBrands = [] } = config;
    const { styles: styles } = elementConfigMap[field] ?? {};
    const searchParameters = new URLSearchParams();
    searchParameters.set("field", field);
    searchParameters.set("environment", environment);
    searchParameters.set("fields", fields.join("|"));
    searchParameters.set("styles", JSON.stringify(styles ?? {}));
    searchParameters.set("excludedCardBrands", excludedCardBrands.join("|"));
    switch(field){
        case "pin":
            {
                const { paymentCardId: paymentCardId = "", masked: masked = false, showToggle: showToggle = false } = elementConfigMap.pin ?? {};
                searchParameters.set("token", clientToken);
                searchParameters.set("paymentCardId", paymentCardId);
                searchParameters.set("masked", String(masked));
                searchParameters.set("showToggle", String(showToggle));
                break;
            }
        case "cardNumber":
            searchParameters.set("token", clientToken);
            break;
        default:
            break;
    }
    const frameSource = new URL(`${(0, $79deca1ff5cf929a$export$f7872bdb68630f49)(environment)}?${searchParameters.toString()}`);
    frameSource.hash = uuid;
    return frameSource;
};
const $cef9da35d4d969ce$export$28ca0294113407cf = (config)=>{
    const frame = document.createElement("iframe");
    const frameSource = $cef9da35d4d969ce$var$buildFrameSource(config);
    frame.setAttribute("src", frameSource.toString());
    frame.style.setProperty("border", "none");
    return frame;
};





const $257be56de53b8273$var$FALLBACK_ERROR_MESSAGE = "Something went wrong. Please try again or contact support.";
const $257be56de53b8273$var$createRouteError = (onPinEntryError, onTokenizeCardError)=>(error)=>{
        onTokenizeCardError?.(error);
        onPinEntryError?.(error);
    };
const $257be56de53b8273$export$221b191fcfaf22a = ({ uuid: uuid, onPinEntryError: onPinEntryError, onInput: onInput, onPinEntrySuccess: onPinEntrySuccess, onTokenizeCardSuccess: onTokenizeCardSuccess, onStateChange: onStateChange, onReady: onReady, onTokenizeCardError: onTokenizeCardError })=>(event)=>{
        if (event.origin !== (0, $79deca1ff5cf929a$export$f76cea9319723dd2) || uuid !== event.data.uuid) return false;
        const { data: data } = event.data;
        const routeError = $257be56de53b8273$var$createRouteError(onPinEntryError, onTokenizeCardError);
        switch(data.__typename){
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).INVALID_CREDENTIAL_ERROR:
                routeError({
                    name: "InvalidCredentialError",
                    context: data.context
                });
                break;
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).ON_PIN_CHANGE_SUCCESS:
                onPinEntrySuccess?.(data.field);
                break;
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).ON_TOKENIZE_CARD_SUCCESS:
                onTokenizeCardSuccess?.(data.paymentMethodToken);
                break;
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).ON_STATE_CHANGE:
                onStateChange?.(data.field, data.state);
                break;
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).ON_INPUT:
                onInput?.(data.field, data.config);
                break;
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).ON_READY:
                onReady?.();
                break;
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).USER_INPUT_ERROR:
                {
                    const { field: field, message: message } = data;
                    const error = {
                        name: "SecureInputsFieldInputError",
                        field: field,
                        message: message
                    };
                    onPinEntryError?.(error);
                    break;
                }
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).REQUEST_ERROR:
                {
                    const { field: field, message: message, context: context } = data;
                    routeError({
                        name: "SecureInputsRequestError",
                        field: field,
                        message: message,
                        context: context
                    });
                    break;
                }
            case (0, $33a93507c43eb206$export$5278e3e6401288b4).GENERIC_ERROR:
                routeError({
                    name: "Error",
                    message: data.message
                });
                break;
            default:
                routeError({
                    name: "Error",
                    message: $257be56de53b8273$var$FALLBACK_ERROR_MESSAGE
                });
                break;
        }
        return true;
    };


const $f46131d0bac9624d$var$unmount = (fields)=>{
    Object.values(fields).forEach((field)=>{
        if (field) field.container.replaceChildren("");
    });
};
const $f46131d0bac9624d$var$submit = (fieldName, field, event)=>{
    const targetWindow = field?.frame.contentWindow;
    if (targetWindow === null || targetWindow === undefined) return {
        name: "SecureInputsSubmitError",
        message: `Unable to submit field: ${fieldName}`
    };
    targetWindow.postMessage(event, (0, $79deca1ff5cf929a$export$f76cea9319723dd2));
    return undefined;
};
const $f46131d0bac9624d$var$generateFields = ({ uuid: uuid, elements: elements, clientToken: clientToken, environment: environment, excludedCardBrands: excludedCardBrands })=>{
    const fields = Object.keys(elements).map((element)=>element);
    const fieldMap = (0, $33a93507c43eb206$export$1ec34c2c9b231c0f).reduce((accum, field)=>{
        const elementConfig = elements[field];
        if (!elementConfig || typeof elementConfig !== "object" || !("selector" in elementConfig)) return accum;
        const config = elementConfig;
        const frame = (0, $cef9da35d4d969ce$export$28ca0294113407cf)({
            clientToken: clientToken,
            uuid: uuid,
            field: field,
            environment: environment,
            fields: fields,
            excludedCardBrands: excludedCardBrands,
            elementConfig: {
                [field]: elementConfig
            }
        });
        const container = document.querySelector(config.selector) ?? document.body;
        container.append(frame);
        return {
            ...accum,
            [field]: {
                frame: frame,
                container: container
            }
        };
    }, {
        pin: undefined,
        cardNumber: undefined,
        expirationYear: undefined,
        expirationDate: undefined,
        expirationMonth: undefined,
        securityCode: undefined
    });
    return fieldMap;
};
const $f46131d0bac9624d$var$renderTokenizationFields = async ({ onStateChange: onStateChange, onSuccess: onSuccess, onError: onError, onReady: onReady, elements: elements, clientToken: clientToken, environment: environment = "test", excludedCardBrands: excludedCardBrands = [] })=>{
    const uuid = (0, $79deca1ff5cf929a$export$1c3aefb711c3a4cc)();
    const fields = $f46131d0bac9624d$var$generateFields({
        uuid: uuid,
        elements: elements,
        clientToken: clientToken,
        environment: environment,
        excludedCardBrands: excludedCardBrands
    });
    window.removeEventListener("message", (0, $257be56de53b8273$export$221b191fcfaf22a)({
        uuid: uuid,
        onTokenizeCardError: onError,
        onTokenizeCardSuccess: onSuccess,
        onStateChange: onStateChange,
        onReady: onReady
    }));
    window.addEventListener("message", (0, $257be56de53b8273$export$221b191fcfaf22a)({
        uuid: uuid,
        onTokenizeCardError: onError,
        onTokenizeCardSuccess: onSuccess,
        onStateChange: onStateChange,
        onReady: onReady
    }));
    return {
        submit: (args)=>{
            const { additionalData: additionalData } = args ?? {};
            return $f46131d0bac9624d$var$submit("cardNumber", fields.cardNumber, {
                __typename: (0, $33a93507c43eb206$export$5278e3e6401288b4).TOKENIZE_CARD,
                additionalData: additionalData
            });
        },
        unmount: async ()=>{
            $f46131d0bac9624d$var$unmount(fields);
        }
    };
};
const $f46131d0bac9624d$var$renderFieldsForPinEntry = async ({ onSuccess: onSuccess, onInput: onInput, onError: onError, elements: elements, clientToken: clientToken, environment: environment = "test" })=>{
    const uuid = (0, $79deca1ff5cf929a$export$1c3aefb711c3a4cc)();
    const fields = $f46131d0bac9624d$var$generateFields({
        uuid: uuid,
        elements: elements,
        clientToken: clientToken ?? elements.pin.clientToken ?? "",
        environment: environment
    });
    window.removeEventListener("message", (0, $257be56de53b8273$export$221b191fcfaf22a)({
        uuid: uuid,
        onInput: onInput,
        onPinEntryError: onError,
        onPinEntrySuccess: onSuccess
    }));
    window.addEventListener("message", (0, $257be56de53b8273$export$221b191fcfaf22a)({
        uuid: uuid,
        onInput: onInput,
        onPinEntryError: onError,
        onPinEntrySuccess: onSuccess
    }));
    return {
        submit: ()=>$f46131d0bac9624d$var$submit("pin", fields.pin, {
                __typename: (0, $33a93507c43eb206$export$5278e3e6401288b4).CHANGE_CARD_PIN
            }),
        unmount: async ()=>{
            $f46131d0bac9624d$var$unmount(fields);
        }
    };
};
const $f46131d0bac9624d$var$isClientTokenDefined = (config)=>config.clientToken !== undefined || "pin" in config.elements && config.elements.pin.clientToken !== undefined;
const $f46131d0bac9624d$export$214cd789bf36dbe8 = async (config)=>{
    if (!$f46131d0bac9624d$var$isClientTokenDefined(config)) throw new Error("clientToken was undefined");
    return await $f46131d0bac9624d$var$renderTokenizationFields(config);
};
const $f46131d0bac9624d$export$1b4461fdcf0903a6 = async (config)=>{
    if (!$f46131d0bac9624d$var$isClientTokenDefined(config)) throw new Error("clientToken was undefined");
    return await $f46131d0bac9624d$var$renderFieldsForPinEntry(config);
};


export {$f46131d0bac9624d$export$214cd789bf36dbe8 as renderFieldsForTokenization, $f46131d0bac9624d$export$1b4461fdcf0903a6 as renderFields};
//# sourceMappingURL=module.js.map
